import type { ApiConfig } from '../../types'

export const tradeHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100,
  order: 'asc',
  range: undefined,
  requiresRange: false,
  type: 'trade-history',
} as const satisfies ApiConfig
